export const environment = {
  production: true,
  arcGisScriptUrl: 'https://js.arcgis.com/4.6/',
  arcGisCssUrl: 'http://js.arcgis.com/4.6/esri/css/main.css'
};
